module.exports = __webpack_public_path__ + "static/mentor-abha-sharma_s-7b716a0d26f537689533521947c6d2fd.jpg";